import G90 from '../../../assets/images/main/testv.mp4'
import G70 from '../../../assets/images/main/g70.mp4'
import G80E from '../../../assets/images/main/g80e.mp4'
import G80 from '../../../assets/images/main/g80.mp4'
import GV70 from '../../../assets/images/main/gv70.mp4'
import GV60 from '../../../assets/images/main/gv60.mp4'

import poster01 from '../../../assets/images/main/poster01.webp'
import poster02 from '../../../assets/images/main/poster02.webp'
import poster03 from '../../../assets/images/main/poster03.webp'
import poster04 from '../../../assets/images/main/poster04.webp'
import poster05 from '../../../assets/images/main/poster05.webp'
import poster06 from '../../../assets/images/main/poster06.webp'

import g90 from '../../../assets/images/main/g90m.jpg'
import g90_webp from '../../../assets/images/main/g90m.webp'
import g70 from '../../../assets/images/main/g70m.jpg'
import g70_webp from '../../../assets/images/main/g70m.webp'
import gv802 from '../../../assets/images/main/gv802m.jpg'
import gv802_webp from '../../../assets/images/main/gv802m.webp'
import gv80 from '../../../assets/images/main/gv80m.jpg'
import gv80_webp from '../../../assets/images/main/gv80m.webp'
import gv70 from '../../../assets/images/main/gv70m.jpg'
import gv70_webp from '../../../assets/images/main/gv70m.webp'
import gv60 from '../../../assets/images/main/gv60m.jpg'
import gv60_webp from '../../../assets/images/main/gv60m.webp'


export const mainVisualList = [
    {
        title: "G90",
        subTxt_1: "여백의 미\n고급스러운 디테일",
        subTxt_2: "최고급 세단에 걸맞은 품격 있는 실내외 디자인은 물론, 첨단 주행 보조 기술과 이동 시간에 가치를 더하는 다양한 기술이 집약된 G90를 통해 고급차의 새로운 방향성을 제시합니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g90-long-wheel-base/bto/powertrains?code=BBBBBBB&packages=",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g90/design.html",
        img: g90,
        img_webp: g90_webp,
        src: G90,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: false,
        preload: "none",
        poster: poster06,
    },
    {
        title: "G70",
        subTxt_1: "럭셔리 디자인\n역동적인 우아함",
        subTxt_2: "2017년 젊고 세련된 디자인의 중형 럭셔리 세단으로 시작한 G70는, 2023년 차별화된 디자인 아이덴티티에 더욱 뛰어난 주행 및 제동 성능의 럭셔리 스포츠 세단으로 새롭게 탄생하였습니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g70/bto/powertrains?code=BCBBBBB&packages=",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g70/design.html",
        img: g70,
        img_webp: g70_webp,
        src: G70 ,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: true,
        preload: "metadata",
        poster: poster01,
    },
    {
        title: "E.G80",
        subTxt_1: "전기차\n 그 이상의 시작",
        subTxt_2: "전기차 그 이상. Electrified G80는 뛰어난 동력 성능과 신기술을 갖춘 제네시스의 첫 번째 전기차 모델로, 고급 대형 전동화 세단의 새로운 기준을 제시합니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/electrified-g80/bto/powertrains?code=BBBBBB&packages=",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/electrified-g80/design.html",
        img: gv802,
        img_webp: gv802_webp,
        src: G80E ,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: false,
        preload: "none",
        poster: poster02,
    },
    {
        title: "G80",
        subTxt_1: "완벽한 비율\n 역동적인 우아함",
        subTxt_2: "역동적인 우아함의 완벽한 균형을 이룬 대형 럭셔리 세단 G80는 고급스러운 감성과 편의사양을 계승하면서 스포티한 감성을 강화한 럭셔리 스포츠 세단으로 재탄생했습니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g80/bto/",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-sedan-genesis/g80/design.html",
        img: gv80,
        img_webp: gv80_webp,
        src: G80 ,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: false,
        preload: "metadata",
        poster: poster03,
    },
    {
        title: "GV70",
        subTxt_1: "심플한 조형\n 감성적인 볼륨",
        subTxt_2: "역동적인 우아함을 극대화한 디자인, 다이내믹한 주행 경험, 여백의 미를 승화한 실내, 커넥티드 카의 신기술이 담긴 도심형 프리미엄 SUV GV70를 소개합니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-suv-genesis/gv70/bto/powertrains?code=BBBBBBB&packages=",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-suv-genesis/gv70/design.html",
        img: gv70,
        img_webp: gv70_webp,
        src: GV70 ,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: false,
        preload: "none",
        poster: poster04,
    },
    {
        title: "GV60",
        subTxt_1: "당신과의\n 교감을 위해",
        subTxt_2: "GV60는 파워풀한 주행성능과 고객과 교감하는 다양한 핵심기능을 통해 럭셔리 전기차의 새로운 기준을 제시합니다.",
        more: "https://www.genesis.com/kr/ko/models/luxury-suv-genesis/gv60/bto/powertrains?code=BBBBB&packages=",
        Learn: "https://www.genesis.com/kr/ko/models/luxury-suv-genesis/gv60/highlights.html",
        img: gv60,
        img_webp: gv60_webp,
        src: GV60 ,
        muted: true, 
        loop: true, 
        playsInline: true,
        autoPlay: false,
        preload: "none",
        poster: poster05,
    },

]